import { gql } from '@apollo/client';

export const FETCH_EXISTING_UTILITY_ACCOUNTS = gql`
  query Flex_FetchExistingUtilityAccounts($userId: Int!) {
    user(id: $userId) {
      id
      accounts {
        id
        utilityAccounts {
          id
          accountNumber
          displayServiceAddress
          hasInValidScraperDetails
          hasVnmProduct
          utility {
            id
            displayName
          }
        }
      }
    }
  }
`;
